import * as React from 'react';
import { ModalBody } from '~ui/components/content/Modal/components/ModalBody';
import { ModalFooter } from '~ui/components/content/Modal/components/ModalFooter';
import { Modal } from '~ui/components/content/Modal/Modal';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/**
 * Modal that renders the guide content.
 * Used on tablet & desktop devices.
 */
export var GuideOverlayModal = function GuideOverlayModal(_ref) {
  var isOpen = _ref.isOpen,
      onClose = _ref.onClose,
      footerContent = _ref.footerContent,
      children = _ref.children;
  return /*#__PURE__*/_jsxs(Modal, {
    size: "sm",
    height: "100%",
    allowAltClosing: true,
    withCloseButton: true,
    isOpen: isOpen,
    onClose: onClose,
    contentOverflow: "hidden",
    closeButtonBgColor: "bgColors.primary",
    children: [/*#__PURE__*/_jsx(ModalBody, {
      padding: "none",
      overflow: "hidden",
      children: children
    }), /*#__PURE__*/_jsx(ModalFooter, {
      padding: {
        top: "smallMedium",
        bottom: "medium",
        left: "medium",
        right: "medium"
      },
      justifyContent: "center",
      children: footerContent
    })]
  });
};